<script>
import DeveloperProfileResource from '../resources/developerprofile'
import ListingResource from '../resources/listing'

export default {
    components: {},
    props: {
        profile: {
            type: DeveloperProfileResource,
            requred: false,
        },
        listing: {
            type: ListingResource,
            required: false,
        },
        compact: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        imageSrc() {
            return String(this.profile.get('image')) || ''
        },
        secondColumnWidth() {
            return this.$slots.default && $slots.default.length > 0 ? 4 : 0
        },
        headline() {
            if(this.profile) {
                let maxLength = 130
                let headline = this.stringMaxLength(this.profile.attributes.headline, maxLength)
                
                if(headline.length > 10 && ~headline.indexOf(' ')) {
                    return {
                        isShortened: headline.length > maxLength,
                        text: headline
                    }
                }
            }
        }
    },
    data() {
        return {
            loading: false,
        }
    },
    methods: {
        stringMaxLength(input, maxLength) {
            if (input.length > maxLength) {
                return input.substring(0, maxLength) + '...'
            }

            return input
        },
        onClick(e) {
            this.$emit('click', e)
        }
    },
    mounted() {
        if (this.profile) {
            this.loading = true
            // Don't need to await this because we don't care about the image loading before the cell renders
            this.profile.resolveRelated({ managers: ['image'] })
            this.loading = false
        }
    },
}
</script>

<template>
    <b-row>
        <b-col sm="2">
            <b-avatar v-if="profile" :src="imageSrc" variant="light" size="6rem" @click="onClick" />
            <b-skeleton v-else type="avatar" variant="light" size="6rem"></b-skeleton>
        </b-col>
        <b-col>
            <div v-if="profile">
                <b-row class="profile">
                    <b-col>
                        <h4><a href="javascript:{}" @click="onClick">{{ profile }}</a></h4>
                        <h6>{{ profile.readonly.primary_role_name }}</h6>
                        <ul class="list-unstyled">
                            <li v-if="profile.readonly.school_headlining_name && profile.readonly.school_headlining_name.split('').slice(0, 4).join('') !== 'None'">
                                <b-icon icon="eyeglasses" /> {{ stringMaxLength(profile.readonly.school_headlining_name, 35) }}
                            </li>
                            <li v-if="profile.workedAt()"><b-icon icon="building" /> {{ stringMaxLength(profile.workedAt(), 35) }}</li>
                            <li><b-icon icon="geo-alt" /> {{ profile.readonly.location_preferred_name }}</li>
                            <li v-if="!compact"><small><a href="javascript:{}" @click="onClick">More...</a></small></li>
                        </ul>
                    </b-col>
                    <b-col :md="$slots.default && $slots.default.length > 0 ? 4 : 6" v-if="!compact">
                        <ul class="list-unstyled mt-3">
                            <li v-if="profile.attributes.years_experience > 1" class="text-success"><b-icon icon="check" /> {{ profile.attributes.years_experience }} Years Experience</li>
                            <li class="text-success"><b-icon icon="check" /> Salary: {{ profile.salaryFormatted() }}</li>
                        </ul>
                        <hr v-if="headline" />
                        <div :class="`headline text-muted ${headline.isShortened ? 'shortened' : ''}`" v-if="headline" @click="onClick">
                            <b-icon icon="chat-right-quote-fill" />
                            <p>{{ headline.text }}</p>
                        </div>
                    </b-col>
                    <b-col v-if="listing && !compact && $slots.default && $slots.default.length > 0" class="text-right" md="3">
                        <slot />
                    </b-col>
                </b-row>
            </div>

            <b-skeleton-wrapper v-else>
                <b-skeleton animation="wave" :width="Math.floor(Math.random() * 35) + 60 + '%'"></b-skeleton>
                <b-skeleton animation="wave" :width="Math.floor(Math.random() * 35) + 60 + '%'"></b-skeleton>
                <b-skeleton animation="wave" :width="Math.floor(Math.random() * 35) + 60 + '%'"></b-skeleton>
            </b-skeleton-wrapper>
        </b-col>
    </b-row>
</template>

<style lang="scss">
.b-avatar {
    cursor: pointer;
}

.profile {
    font-size: 0.9em;
}
</style>
